module.exports = "/_next/static/images/WaterSewageSystemPipelineFacilities-29da398675d829ea23d88d9274f31117.webp";